import {
  MenuItem,
  ListSubheader,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
  InputProps,
  OutlinedInput,
  styled,
} from '@mui/material'

export type Option = {
  label: string
  value: string | number
}

export type GroupOption = {
  label: string
  options: Option[]
}

export type SelectOption = Option | GroupOption

export type SelectOptions = SelectOption[]

export type SelectProps = {
  options?: SelectOptions
} & MuiSelectProps &
  InputProps

const genMenuItem = ({ label, value }: Option) => (
  <MenuItem key={`${label}_${value}`} value={value}>
    {label}
  </MenuItem>
)

function isGroupOption(option: SelectOption): option is GroupOption {
  return 'options' in option
}

const GroupLabel = styled(ListSubheader)(({ theme }) => ({
  root: {
    fontWeight: 'bold',
    pointerEvents: 'none',
    userSelect: 'none',
    background: theme.palette.background.default,
  },
}))

function Select({ options, ...props }: SelectProps) {
  const menuItems = (options || []).map((option: SelectOption) => {
    if (isGroupOption(option)) {
      return [
        <GroupLabel key={option.label} color="inherit">
          {option.label}
        </GroupLabel>,
        ...option.options.map(genMenuItem),
      ]
    }
    return genMenuItem(option)
  })

  return (
    <MuiSelect
      fullWidth
      displayEmpty
      variant="outlined"
      margin="dense"
      input={<OutlinedInput classes={props?.classes} />}
      {...props}
    >
      {menuItems}
    </MuiSelect>
  )
}

export default Select
